import Vue from 'vue';
import Router from 'vue-router';
import AccountCore from '@/views/AccountCore.vue';
import AccountProduct from '@/views/AccountProduct.vue';
import Filemover from '@/views/FileMover.vue';
import MulesoftFi from '@/views/MulesoftFi.vue';
import PaymentProcessor from '@/views/PaymentProcessor.vue';
import MulesoftCore from '@/views/MulesoftCore.vue';
import GhostLoan from '@/views/GhostLoan.vue';
import NxtsofFi from '@/views/NxtsofFi.vue';
import CldLoanImporter from '@/views/CldLoanImporter.vue';
import ErrorPage from '@/views/ErrorPage.vue';
import GenericWhitelist from '@/views/GenericWhitelist.vue';
import MeridianLink from '@/views/MeridianLink.vue';

Vue.use(Router);

export default new Router({
  routes: [
    { path: '/', redirect: '/mulesoftcore' },
    /*
    {
      path: '/accountcore',
      name: 'accountcore',
      component: AccountCore,
    },
    {
      path: '/accountproduct',
      name: 'accountproduct',
      component: AccountProduct,
    },
     */
    {
      path: '/genericwhitelist',
      name: 'genericwhitelist',
      component: GenericWhitelist,
      meta: { title: 'Whitelist FI' },
    },
    {
      path: '/filemover',
      name: 'filemover',
      component: Filemover,
    },

    {
      path: '/mulesoftfi',
      name: 'mulesoftfi',
      component: MulesoftFi,
    },

    {
      path: '/error',
      name: 'error',
      component: ErrorPage,
      meta: {
        header: 1,
      },
    },

    {
      path: '/mulesoftcore',
      name: 'mulesoftcore',
      component: MulesoftCore,
      meta: { title: 'Mulesoft Core' },
    },

    {
      path: '/ghostloan',
      name: 'ghostloan',
      component: GhostLoan,
      meta: { title: 'Ghost Loan Config' },
    },
    {
      path: '/paymentprocessor',
      name: 'paymentprocessor',
      component: PaymentProcessor,
      meta: { title: 'Payment Processor' },
    },
    {
      path: '/nxtsoffi',
      name: 'nxtsoffi',
      component: NxtsofFi,
      meta: { title: 'Nxtsof Config' },
    },
    {
      path: '/cldloanimporter',
      name: 'cldloanimporter',
      component: CldLoanImporter,
      meta: { title: 'CLD Loan Importer Config' },
    },
    {
      path: '/meridianlink',
      name: 'meridianlink',
      component: MeridianLink,
      meta: { title: 'Meridian Link' },
    },

  ],


  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        offset: { x: 0, y: 75 },
      };
    }
    return {
      x: 0,
      y: 0,
    };
  },
});
